// extracted by mini-css-extract-plugin
export default {"previous":"Previous_previous__6Do3M"};